import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Player } from '../../data/models/player.model';
import { Observable, Subject } from 'rxjs';
import { EventEmitter } from 'protractor';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  editing = false;

  selectedSvg;
  changeSvgIds = [];

  malePlayerSvg = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="male" class="svg-inline--fa fa-male fa-w-6" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path fill="COLOR_VALUE" d="M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"></path></svg>';
  femalePlayerSvg = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="female" class="svg-inline--fa fa-female fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="COLOR_VALUE" d="M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"></path></svg>';
  femaleCircleSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="1316" height="1238" viewBox="0 0 1316 1238"><path style="fill: COLOR_VALUE;stroke:COLOR_VALUE;stroke-width: 4;" d="M924,16c171.01,72.721,299.96,232.439,350,427,25.53,99.255,17.66,237.954-10,327-59.34,191.013-181.85,325.95-357,401-46.575,19.96-97.151,33.39-154,45q-29.5,2.505-59,5-36,.495-72,1c-53.7-9.02-102.264-11.65-148-26C265.741,1130.65,117.57,982.076,52,774-32.514,505.808,91.293,234.923,240,116c35.368-28.284,69.16-53.885,110-78,11-6.5,22.892-16.423,37-19L653,285l97-97Z"/></svg>';
  maleCircleSvg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1316" height="1238" viewBox="0 0 1316 1238"><path d="M1253,19V1216H56V19l329-1L653,285l97-97L922,18Z" style="fill:COLOR_VALUE; stroke:COLOR_VALUE; stroke-width: 4;"/></svg>';

  startSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 51 48"><path fill="none" stroke="#000" d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"/></svg>'
  kiwiSvg = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30" height="30" viewBox="0 65.326 612 502.174" enable-background="new 0 65.326 612 502.174" xml:space="preserve"><ellipse fill="#C6C6C6" cx="283.5" cy="487.5" rx="259" ry="80"/><path id="bird" d="M210.333,65.331C104.367,66.105-12.349,150.637,1.056,276.449c4.303,40.393,18.533,63.704,52.171,79.03c36.307,16.544,57.022,54.556,50.406,112.954c-9.935,4.88-17.405,11.031-19.132,20.015c7.531-0.17,14.943-0.312,22.59,4.341c20.333,12.375,31.296,27.363,42.979,51.72c1.714,3.572,8.192,2.849,8.312-3.078c0.17-8.467-1.856-17.454-5.226-26.933c-2.955-8.313,3.059-7.985,6.917-6.106c6.399,3.115,16.334,9.43,30.39,13.098c5.392,1.407,5.995-3.877,5.224-6.991c-1.864-7.522-11.009-10.862-24.519-19.229c-4.82-2.984-0.927-9.736,5.168-8.351l20.234,2.415c3.359,0.763,4.555-6.114,0.882-7.875c-14.198-6.804-28.897-10.098-53.864-7.799c-11.617-29.265-29.811-61.617-15.674-81.681c12.639-17.938,31.216-20.74,39.147,43.489c-5.002,3.107-11.215,5.031-11.332,13.024c7.201-2.845,11.207-1.399,14.791,0c17.912,6.998,35.462,21.826,52.982,37.309c3.739,3.303,8.413-1.718,6.991-6.034c-2.138-6.494-8.053-10.659-14.791-20.016c-3.239-4.495,5.03-7.045,10.886-6.876c13.849,0.396,22.886,8.268,35.177,11.218c4.483,1.076,9.741-1.964,6.917-6.917c-3.472-6.085-13.015-9.124-19.18-13.413c-4.357-3.029-3.025-7.132,2.697-6.602c3.905,0.361,8.478,2.271,13.908,1.767c9.946-0.925,7.717-7.169-0.883-9.566c-19.036-5.304-39.891-6.311-61.665-5.225c-43.837-8.358-31.554-84.887,0-90.363c29.571-5.132,62.966-13.339,99.928-32.156c32.668-5.429,64.835-12.446,92.939-33.85c48.106-14.469,111.903,16.113,204.241,149.695c3.926,5.681,15.819,9.94,9.524-6.351c-15.893-41.125-68.176-93.328-92.13-132.085c-24.581-39.774-14.34-61.243-39.957-91.247c-21.326-24.978-47.502-25.803-77.339-17.365c-23.461,6.634-39.234-7.117-52.98-31.273C318.42,87.525,265.838,64.927,210.333,65.331z M445.731,203.01c6.12,0,11.112,4.919,11.112,11.038c0,6.119-4.994,11.111-11.112,11.111s-11.038-4.994-11.038-11.111C434.693,207.929,439.613,203.01,445.731,203.01z"/></svg>';
  batmanSvg = '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30" height="30" viewBox="0 0 460.001 460.001" style="enable-background:new 0 0 460.001 460.001;" xml:space="preserve"><g><path d="M209.195,326.458l-91.46-38.359c-2.957-1.241-6.329-0.987-9.067,0.68c-2.739,1.667-4.512,4.546-4.769,7.742c-2.154,26.854,13.093,51.897,37.941,62.319c7.675,3.219,15.756,4.851,24.02,4.851c18.062,0,35.201-7.822,47.024-21.461c2.1-2.423,2.911-5.706,2.181-8.827C214.334,330.281,212.151,327.698,209.195,326.458z M165.859,343.691c-5.593,0-11.071-1.109-16.284-3.295c-12.136-5.09-20.896-15.321-24.306-27.45l60.906,25.544C180.02,341.866,173.047,343.691,165.859,343.691z"/><path d="M394.87,0.131c-4.841-0.789-9.535,2.045-11.091,6.693l-55.704,166.286c-28.719-19.709-63.039-30.432-98.075-30.432s-69.355,10.724-98.075,30.432L76.222,6.825c-1.557-4.648-6.251-7.482-11.091-6.693c-4.837,0.789-8.391,4.968-8.391,9.87v359.52c0,3.808,2.163,7.286,5.579,8.969l163.26,80.48c1.394,0.687,2.908,1.031,4.421,1.031s3.028-0.344,4.421-1.031l163.26-80.48c3.416-1.684,5.579-5.161,5.579-8.969V10.001C403.261,5.099,399.708,0.92,394.87,0.131z M383.261,363.301l-153.26,75.551L76.74,363.301V71.335l40.616,121.247c1.043,3.114,3.549,5.518,6.704,6.43c3.155,0.913,6.558,0.217,9.102-1.86c27.234-22.231,61.625-34.475,96.838-34.475s69.604,12.243,96.838,34.475c2.545,2.077,5.947,2.771,9.102,1.86c3.155-0.912,5.661-3.316,6.704-6.43l40.616-121.247V363.301z"/><path d="M250.806,326.458c-2.957,1.24-5.14,3.823-5.87,6.945c-0.73,3.122,0.081,6.405,2.181,8.827c11.823,13.639,28.962,21.461,47.024,21.461c8.263,0,16.344-1.632,24.02-4.851c24.848-10.421,40.095-35.465,37.941-62.319c-0.257-3.196-2.03-6.075-4.769-7.742c-2.739-1.667-6.111-1.92-9.067-0.68L250.806,326.458z M310.426,340.396c-5.213,2.186-10.691,3.295-16.284,3.295c-7.188,0-14.16-1.825-20.315-5.2l60.906-25.544C331.322,325.075,322.562,335.306,310.426,340.396z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';

  svgImages = [];

  mmToPx = 3.7795275590551;

  public selectSvgImage = new Subject<any>();
  public refreshSvgImage = new Subject<any>();
  public reloadSvgImage = new Subject<any>();

  getSelectSvgImage(): Observable<any> {
    return this.selectSvgImage.asObservable();
  }

  getRefreshSvgImage(): Observable<any> {
    return this.refreshSvgImage.asObservable();
  }

  getReloadSvgImage(): Observable<any> {
    return this.reloadSvgImage.asObservable();
  }

  save(player: Player) {
    return this.http.post<any>('/api/participant/save', player);
  }

  saveAll(players: Player[], fromReset) {
    return this.http.post<any>('/api/participant/saveAll?fromReset='+fromReset, players);
  }

  getParticipants() : Observable<Player[]> {
    let therapist = JSON.parse(localStorage.getItem('therapist'));
    return this.http.get<Player[]>('/api/participant/all/'+therapist.id);
  }

  toggleShowText() {
    return this.http.post<any>('/api/participant/toggleShowText', null);
  }

  toggleIconType() {
    return this.http.post<any>('/api/participant/toggleIconType', null);
  }

  setShowText(value: boolean) {
    return this.http.post<any>('/api/participant/setShowText?value='+value, null);
  }

  saveImg(data) {
    return this.http.post<any>('/api/svg_img/save', data);
  }

  getAllImg() {
    let therapist = JSON.parse(localStorage.getItem('therapist'));
    return this.http.get<any>('/api/svg_img/all/'+therapist.id);
  }

  deleteImg(id) {
    return this.http.post<any>('/api/svg_img/delete/'+id, null);
  }

  getImageBySvgId(id) {
    let therapist = JSON.parse(localStorage.getItem('therapist'));
    const requestOptions: Object = {
      /* other options here */
      responseType: 'blob'
    }
    return this.http.get<any>("/api/svg_img/image/"+therapist.id+"/"+id, requestOptions);
  }

  getSvgFigures() {
    this.svgImages = [];
    this.getAllImg().subscribe(data1 => {
      let data = [];
      for(let i=0; i<data1.length;i++) {
        data.push({id: data1[i].id, img: null});
        this.getImageBySvgId(data1[i].id).subscribe((dataImg) => {
          var reader = new FileReader();
          reader.readAsText(dataImg);
          reader.onload = () => {
            data[i].img = reader.result.toString();
            if(i==data1.length-1) {
              setTimeout(() => {
                this.imgLoaded(data);
              }, 500);
            }
          }
        });
      }
    });
  }

  imgLoaded(data) {
    for(let i=0; i<data.length;i++) {
      let svg = data[i].img;
      if(svg) {
        let height = 'height="';
        let heightStartIdx = svg.indexOf(height);
        let heightIdx = heightStartIdx+height.length;
        let heightValue = "";
        while(heightIdx<svg.length) {
          let ch = svg.charAt(heightIdx);
          if(ch=='"') {
            heightValue = svg.substr(heightStartIdx, heightIdx-heightStartIdx+1);
            break;
          }
          heightIdx++;
        }
        if(heightValue!="" && heightValue.includes(height)) {
          svg = svg.replace(heightValue,"");
        }
        let width = 'width="';
        let widthStartIdx = svg.indexOf(width);
        let widthIdx = widthStartIdx+width.length;
        let widthValue = "";
        while(widthIdx<svg.length) {
          let ch = svg.charAt(widthIdx);
          if(ch=='"') {
            widthValue = svg.substr(widthStartIdx, widthIdx-widthStartIdx+1);
            break;
          }
          widthIdx++;
        }
        if(widthValue!="" && widthValue.includes(width)) {
          svg = svg.replace(widthValue,"");
        }
        var closeIdx = svg.indexOf(">");
        if(closeIdx>-1) {
          let dataImg = svg.substr(0, closeIdx);
          let width = 30, height=30;
          let transformWidth = 0, transformHeight = 0;
          if(heightValue.includes("mm") && widthValue.includes("mm")) {
            width = 50;
            height=50;
            let heightNum = heightValue.replace('height="', "");
            let isWidthInMM = widthValue.includes("mm");
            let isHeightInMM = heightValue.includes("mm");
            heightNum = isHeightInMM ? heightNum.replace('mm"', "") : heightNum.replace('px"', "");
            heightValue = heightNum;
            let widthNum = widthValue.replace('width="', "");
            widthNum = isWidthInMM ? widthNum.replace('mm"', "") : widthNum.replace('px"', "");
            widthValue = widthNum;
            let widthPx = (+widthValue)*(isWidthInMM ? this.mmToPx : 1);
            let heightPx = (+heightValue)*(isHeightInMM ? this.mmToPx : 1);
            if(widthValue<heightValue) {
              width = (width * widthPx) / heightPx;
              width = Math.floor(width);
              console.log(width);
            } else {
              height = (height * heightPx) / widthPx;
              height = Math.floor(height);
            }
            transformWidth = width / widthPx;
            transformHeight = height / heightPx;
            console.log(widthNum);
            console.log(heightNum);
            console.log(transformWidth);
            console.log(transformHeight);
            let geoStartIdx = svg.indexOf("<g");
            let geoIdx = geoStartIdx;
            while(geoIdx<svg.length) {
              let ch = svg.charAt(geoIdx);
              if(ch=='>') {
                let replaceString =svg.substr(geoStartIdx, geoIdx-geoStartIdx+1);
                let replacerString =svg.substr(geoStartIdx, geoIdx-geoStartIdx)+' transform="matrix('+transformWidth+' 0 0 '+transformHeight+' 0 0)" >';
                if(replaceString.includes('transform="')) {
                  let transformStartIdx = replaceString.indexOf('transform="');
                  let transformIdx = transformStartIdx+('transform="').length;
                  while(transformIdx<replaceString.length) {
                    let ch1 = replaceString.charAt(transformIdx);
                    if(ch1=='"') {
                      let tranformReplacerString =  replaceString.substr(transformStartIdx, transformIdx-transformStartIdx+1);
                      replaceString = replaceString.replace(tranformReplacerString, "");
                      break;
                    }
                    transformIdx++;
                  }
                }
                svg = svg.replace(replaceString, replacerString);
                break;
              }
              geoIdx++;
            }
            
          }
          svg = svg.replace(dataImg,dataImg+' width="'+width+'px" height="'+height+'px"');
        }
        if(data[i].id==21) {
          console.log(svg);
        }
        this.svgImages.push({id: data[i].id, img: this.sanitizer.bypassSecurityTrustHtml(svg)});
      }
    }
    console.log(this.svgImages);
    this.reloadSvgImage.next(Date());
    this.refreshSvgImage.next(Date());
  }
}
